import valid from '../valid.js'

export default button => {
  valid(button, {cancel : 1})
}
